import React, { createContext, useContext } from 'react'

const SearchContext = createContext<any>({})

function useSearchContext() {
    return useContext(SearchContext)
}

export { SearchContext, useSearchContext }
